import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ShebaField } from '../sheba-field/sheba-field';
import { findBankLogoColor } from 'utils/utils';

interface BankCardProps {
    bank?: any;
}

const Styled = {
    BankCard: styled(Box, {
        shouldForwardProp: (prop) => prop !== 'bank',
    })<BankCardProps>(({ theme, bank }) => {
        const bankLogoColor = findBankLogoColor(bank.name);

        return {
            width: '100%',
            height: '170px',
            padding: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                height: '250px',
                padding: theme.spacing(2),
            },
            borderRadius: 8,
            display: 'flex',
            justifyContent: 'center',
            zIndex: 2,
            color: theme.palette.primary.contrastText,
            background: `
            url("/images/pattern.svg"),
            linear-gradient(216deg, ${bankLogoColor || theme.palette.primary.main} 0%, ${bankLogoColor || theme.palette.primary.dark} 100%)`,
            '.card-layout': {
                width: '100%',
                height: '100%',
                zIndex: 3,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
                '.fa-regular.fa-university': {
                    transform: 'translate(0px, -8px) !important',
                },
            },
            '.card-title': {
                marginBottom: '25px',
                fontFamily: 'YekanBalkhHeavy',
                color: 'inherit',
                fontSize: '.925rem',
                margin: '0 !important',

                [theme.breakpoints.up('sm')]: {
                    fontSize: '1rem',
                },
            },
            '.card-name': {
                width: '100%',
                fontFamily: 'YekanBalkhHeavy',
                color: 'inherit',
                fontSize: '1.125rem',
                textAlign: 'center',
            },
        };
    }),
    ShebaField: styled(ShebaField)(({ theme }) => {
        return {
            '&.MuiFormControl-root': {
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                '.MuiFormHelperText-root': {
                    display: 'none',
                },
                '& .MuiTypography-root': { color: 'inherit' },
                '& label.MuiFormLabel-root': {
                    color: 'inherit',
                },
                '.MuiInputBase-root': {
                    width: 'fit-content',
                    maxWidth: '100%',
                    margin: '0 auto',
                    justifyContent: 'center',
                    color: 'inherit !important',
                    WebkitTextFillColor: 'inherit !important',
                    background: 'transparent !important',
                    backgroundColor: 'transparent !important',
                    boxShadow: 'none !important',
                    '.MuiInputBase-input': {
                        color: 'inherit !important',
                        WebkitTextFillColor: 'inherit !important',
                        fontFamily: 'OCRA',
                        fontSize: '0.55rem',
                        textFillColor: 'inherit !important',
                        background: 'transparent !important',
                        backgroundColor: 'transparent !important',
                        padding: '0 4px !important',
                        width: '29ch',
                        flex: '0 0 29ch',
                        textAlign: 'center !important',
                        [theme.breakpoints.up('sm')]: {
                            padding: '0 8px !important',
                            fontSize: '0.8rem',
                            width: '29ch',
                            flexBasis: '29ch',
                        },
                    },
                    '.MuiInputAdornment-root': {
                        color: 'inherit !important',
                        background: 'transparent !important',
                        backgroundColor: 'transparent !important',
                        border: 'none',
                        margin: '0 !important',
                        padding: '5px !important',

                        p: {
                            color: 'inherit !important',
                            fontFamily: 'OCRA',
                            fontSize: '0.55em',
                            [theme.breakpoints.up('sm')]: {
                                padding: theme.spacing(1),
                                fontSize: '0.8rem',
                                transform: 'translate(0px, 1px) !important',
                            },
                        },
                    },
                    '&.Mui-error': {
                        color: 'inherit !important',
                        WebkitTextFillColor: 'inherit !important',
                        '.MuiInputBase-input, .MuiInputAdornment-root, .MuiTypography-root': {
                            color: 'inherit !important',
                            WebkitTextFillColor: 'inherit !important',
                        },
                        fieldset: {
                            border: 'none !important',
                        },
                    },
                    '& fieldset': {
                        border: 'none !important',
                    },
                },
            },
        };
    }),
};

export { Styled };
